import { global } from "../../constants";

export const data = {
  slide: {
    title: "Comprehensive Logistics Solutions for Merchant Seamen",
    subtitle:
      "Experts in port logistics, technical consulting, and management of international maritime documentation.",
  },

  services: {
    tag: "Services",
    title: "All Services",
    subtitle: "Trusted for Our Services",
    description:
      "We offer a comprehensive portfolio of services designed to meet the highest quality standards. The trust our clients place in us is a direct result of our dedication, professionalism, and consistent delivery of excellence.",
    services: [
      {
        image: global.sgallery + "1.jpg",
        title: "Maritime Law",
        serial: "01",
        url_service: "/services/maritime-law",
        description:
          "We provide specialized legal advice and assistance in Maritime Law, offering comprehensive and tailored solutions for each case.",
      },
      {
        image: global.sgallery + "tributario.webp",
        title: "Tax Law",
        serial: "02",
        url_service: "/services/tax-law",
        description:
          "We offer comprehensive tax and customs planning services, starting with the identification of your economic activity and business model.",
      },
      {
        image: global.sgallery + "aduanero.webp",
        title: "Customs Law",
        serial: "03",
        url_service: "/services/customs-law",
        description:
          "We analyze your operation, identify applicable regulations, and create strategies for compliance, risk reduction, and performance improvement.",
      },
      {
        image: global.sgallery + "mercantil.webp",
        title: "Commercial Law",
        serial: "04",
        url_service: "/services/commercial-law",
        description:
          "We manage the incorporation of your Venezuelan company, carry out all legal procedures, and draft commercial contracts.",
      },
      {
        image: global.sgallery + "seguro.webp",
        title: "Insurance",
        serial: "05",
        url_service: "/services/insurance",
        description:
          "We determine the necessary insurance and bonds for your business, including asset protection for foreign trade and transportation, as well as corporate personal insurance.",
      },
      {
        image: global.sgallery + "administrivo.webp",
        title: "Administrative Processes",
        serial: "06",
        url_service: "/services/administrative-processes",
        description:
          "Management activities to coordinate navigation, port operations, and maritime trade, ensuring safety and legal compliance.",
      },
      {
        image: global.sgallery + "sts.webp", // la imagen la proporcionas tú
        title: "STS Operations",
        serial: "07",
        url_service: "/services/operations-sts",
        description:
          "We safely manage Ship-to-Ship (STS) operations for the transfer of hydrocarbons and liquid cargoes, ensuring regulatory compliance, risk management, and specialized technical supervision.",
      },
    ],
  },

  clients: {
    "title": "Our Partners",
    "logos": [
    {img: global.logo + "aras-shipping.webp", url: "https://arasshipping.us/"},
  ]},

  whychoosus: {
    title: "Why Choose Us",
    subtitle: "We Are Professional Logistics & cargo Agency",
    description:
      "Your strategic partner in the global supply chain, offering professional, efficient, and reliable logistics and freight solutions.",
    branches: "200+",
    solutions: "Comprehensive Solutions",
    since: "Since 2015",
    specifications: [
      "Go beyond logistics, make the world go round and revolutionize business.",
      "Logistics through innovation, dedication, and technology. ready, set, done.",
      "We take pride in serving our customers safely. together with passion.",
      "Imagination what we can easily see is only a small percentage.",
      "Quality never goes out of style. safety, quality, professionalism.",
      "The quality shows in every move we make where business lives.",
    ],
  },

  approach: {
    title: "Company Approch",
    subtitle: "Reliable Logistic & Transport Solutions",
    yearsOfExperience: "35",
    slogan:
      "Years of experience as a comprehensive consulting firm for business and foreign trade.",
    specifications: [
      {
        icon: global.icons + "c-pic1.png",
        count: "10",
        title: "Professional Staff",
      },
      {
        icon: global.icons + "pic7.png",
        count: "80",
        title: "STS Operations",
      },
      {
        icon: global.icons + "c-pic3.png",
        count: "50",
        title: "Technology and Media",
      },
    ],
  },

  projects: {
    title: "Projects",
    subtitle: "Featured Projects",
    description:
      "Our most notable projects include tax optimization for shipping companies, legal defense in international maritime disputes, and the implementation of customized property insurance for large cargo shipments, always guaranteeing legal certainty and efficiency.",
    readMore: "Read More",
    projects: [
      {
        image: global.projects + "1.jpg",
        title: "Storage, Distribution",
        subtitle: "Warehouse Inventory",
        caption: "",
      },
      {
        image: global.projects + "transfers.webp",
        title: "STS Transfer Processes",
        subtitle: "Safe and Efficient Operations",
        caption: "",
      },
      {
        image: global.projects + "contents.webp",
        title: "Container Handling",
        subtitle: "Best Loading Practices",
        caption: "",
      },
      {
        image: global.projects + "4.jpg",
        title: "Storage, Distribution",
        subtitle: "Warehouse Inventory",
        caption: "",
      },
      {
        image: global.projects + "clinsh.webp",
        title: "STS Transfer Inspections",
        subtitle: "Security Audits and Compliance",
        caption: "",
      },
      {
        image: global.projects + "6.jpg",
        title: "Storage, Distribution",
        subtitle: "Warehouse Inventory",
        caption: "",
      },
    ],
  },
};
